import { useMemo } from 'react';
import Loader from '../elements/Loader';
import LocationsUploadResults from '../molecules/ImportLocations/LocationUploadResults';
import LocationsDocumentUpload from '../molecules/ImportLocations/LocationsDocumentUpload';
import LocationsPreview from '../molecules/ImportLocations/LocationsPreview';
import { useFileUpload } from '../../context/LocationUploadContext';

interface ImportLocationsModalProps {
  onOpen?: () => void;
}

const ImportLocationsModal = ({ onOpen }: ImportLocationsModalProps) => {
  const {
    uploadInProcess,
    errors,
    locationsCount,
    parsedUploadedData,
    isOpenInput,
    checkExistingLocationsResponse,
    handleOnDocumentSelect,
    handleCreateLocations,
    handleReload,
    isCheckLocationsLoading,
    isCreateLocationsLoading,
    setIsOpenInput,
    locationsData,
    createLocationsErrors,
  } = useFileUpload();

  const onUploadNewCSV = () => {
    handleReload();
    setIsOpenInput(true);
  };

  const showResults = useMemo(
    () => !!locationsData?.data || !!createLocationsErrors,
    [locationsData, createLocationsErrors],
  );
  const showImportLocations = useMemo(
    () => !parsedUploadedData && !errors && !showResults,
    [parsedUploadedData, errors, showResults],
  );
  const showLocationsPreview = useMemo(
    () => (!!parsedUploadedData || !!errors) && !showResults,
    [parsedUploadedData, errors, showResults],
  );

  if (isCreateLocationsLoading || isCheckLocationsLoading)
    return (
      <div className='flex justify-center items-center bg-white rounded-lg w-full h-full'>
        <Loader fillColor='#6923F4' size='40px' />
      </div>
    );

  return (
    <div
      className='flex justify-center items-center bg-white rounded-lg w-full h-full'
      data-test-id='import-locations-modal'
    >
      {showImportLocations && (
        <LocationsDocumentUpload
          uploadInProcess={uploadInProcess}
          onDocumentSelect={handleOnDocumentSelect}
          onCancel={window.close}
          isOpenInput={isOpenInput}
          setIsOpenInput={setIsOpenInput}
          open={onOpen}
        />
      )}

      {showLocationsPreview && (
        <LocationsPreview
          uploadedLocations={parsedUploadedData || []}
          locationsCount={locationsCount}
          locationsReport={checkExistingLocationsResponse}
          uploadErrors={errors}
          onCancel={window.close}
          onCreate={handleCreateLocations}
          onUploadNewCSV={onUploadNewCSV}
        />
      )}

      {showResults && (
        <LocationsUploadResults
          onClose={window.close}
          onUploadNewCSV={onUploadNewCSV}
          createLocationsResult={locationsData?.data}
          createLocationsErrors={errors}
          locationsCount={locationsCount}
        />
      )}
    </div>
  );
};

export default ImportLocationsModal;
